import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Letter } from '@schoolbelle/api/letter';
import { ReadTableRowData } from '@schoolbelle/api/letter-read';

@Component({
  selector: 'app-charts-carousel',
  templateUrl: './charts-carousel.component.html',
  styleUrls: ['./charts-carousel.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class ChartsCarouselComponent implements OnInit {
  @Input() letter:Partial<Letter>;
  @Input() rows:ReadTableRowData[] = [];
  @Input() hasSurvey:boolean = false;
  @Input() target_cnt:number = 0;
  @Input() read_cnt:number = 0;
  @Input() reply_cnt:number = 0;
  // index = 0;
  // prev:boolean = false;
  // next:boolean = false;

  // subscription = new Subscription();
  constructor (
    // private elRef:ElementRef,
  ) {}
  ngOnInit() {}
  ngAfterViewInit () {
    // const prev = this.elRef.nativeElement.querySelector('.carousel-control-prev');
    // const next = this.elRef.nativeElement.querySelector('.carousel-control-next');
    // if (prev) this.subscription.add(fromEvent(prev, 'mouseenter').subscribe(()=>{
    //   this.next = false;
    //   this.prev = true;
    //   console.log('pre');
    // }))
    // if (next) this.subscription.add(fromEvent(next, 'mouseenter').subscribe(()=>{
    //   this.prev = false;
    //   this.next = true;
    //   console.log('next');
    // }))
  }
  ngOnDestroy () {
    // this.subscription.unsubscribe();
  }


}    